export enum ThemeBreakpoint {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
  CONTAINER = 'container',
}

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: false;
    sm: false;
    md: false;
    lg: false;
    xl: false;
    [ThemeBreakpoint.MOBILE]: true;
    [ThemeBreakpoint.DESKTOP]: true;
    [ThemeBreakpoint.CONTAINER]: true;
  }
}
